module.exports = __webpack_public_path__ + "img/spinazieschotel-met-tomaten-en-rijst.f69978a5.jpg";